import axios from 'axios';
import { defineStore } from 'pinia';
import { PEQUITY_API_URL } from '@/types';

export const useAppConfigStore = defineStore('appConfig', {
  state: () => ({
    isLoaded: false,
    tenantSubdomainsEnabled: true,
  }),
  getters: {
    showTenantFinder: (state): boolean => state.tenantSubdomainsEnabled,
  },
  actions: {
    async fetchAppConfig() {
      if (this.isLoaded) return;

      try {
        const { data } = await axios.get(`${PEQUITY_API_URL}/app-config/`);
        this.tenantSubdomainsEnabled = data.tenant_subdomains_enabled ?? true;
      } catch {
        this.tenantSubdomainsEnabled = true;
      } finally {
        this.isLoaded = true;
      }
    },
  },
});
